export {homePageQuery} from './homePage.groq'
export {newsPageQuery} from './newsPage.groq'
export {privacyPageQuery, privacyPageSeoQuery} from './privacyPage.groq'
export {maintenancePageQuery} from './maintenancePage.groq'
export {contactPageQuery, contactPageSeoQuery} from './contactPage.groq'
export {termsPageQuery, termsPageSeoQuery} from './termsPage.groq'
export {companyPageQuery, companyPageSeoQuery} from './companyPage.groq'
export {technologyPageQuery, technologyPageSeoQuery} from './technologyPage.groq'
